import Page from "../../components/Page";
import useParticipantsList from "./hooks/useParticipantsList";

const ParticipantsList = () => {
  const page = useParticipantsList();
  return <Page {...page} />;
};

export default ParticipantsList;
